<template>
    <auth-common-form
        form-type="register-form"
        registration-user-type="legal_entity">
        <template #title>{{ $t('AUTH.REGISTER.PROFESSIONAL_TITLE') }}</template>
        <template #subtitle>{{ $t('AUTH.REGISTER.PROFESSIONAL_DESC') }}</template>
    </auth-common-form>
</template>

<script>
    import AuthCommonForm from '../components/AuthCommonForm';

    export default {
        name: 'RegisterProfessional',
        components: {
            AuthCommonForm
        },
    };
</script>
